import React, { createContext, useContext, ReactNode, useEffect, useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { useThemeStore } from '../../themeStore';
import { defaultLightColors, ThemeColors } from '../../../types/ThemeModel';
import { getMuiTheme } from '../../../../themes/muiTheme';
import { useAuthStore, AuthState } from '../../auth.store';


interface ThemeContextType {
  theme: 'light' | 'dark';
  colors: ThemeColors | null;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{children: ReactNode}> = ({ children }) => {
  const { theme, colors, setColors, setTheme } = useThemeStore();
  const token = useAuthStore((state: AuthState) => state.token);
  useEffect(() => {
    

    const storedTheme = (localStorage.getItem('theme') as 'light' | 'dark') || 'light';
    const storedColors = localStorage.getItem('colors');

    setTheme(storedTheme);

    if (!token) {    
      setColors(defaultLightColors);
    } else if (storedColors) {
      const parsed = JSON.parse(storedColors) as ThemeColors;      
      setColors(parsed);
    }
  }, [setTheme, setColors, token]);

  // 🔹 Guardar en localStorage cada vez que cambien
  useEffect(() => {
    if (colors) {
      localStorage.setItem('colors', JSON.stringify(colors));
    }
    localStorage.setItem('theme', theme);
  }, [theme, colors]);

  const toggleTheme = () => setTheme(theme === 'light' ? 'dark' : 'light');
  const muiTheme = useMemo(() => getMuiTheme(theme, colors), [theme, colors]);

  return (
    <ThemeContext.Provider value={{ theme, colors, toggleTheme }}>
      <MuiThemeProvider theme={muiTheme}>
        <div data-theme={theme}>{children}</div>
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be inside ThemeProvider');
  return ctx;
};
 
